<template>
  <div class="bg-white m-3 rounded-md">
    <div class="bg-white rounded-md pt-3">
      <p class="text-sm font-semibold pb-3 px-3 border-b-0.5">Benefits</p>
      <div class="mt-3">
        <el-tabs type="border-card" @tab-click="(e) => setTab(e)">
          <el-tab-pane
            v-for="(tab, index) in filteredTabs"
            :key="index"
            :label="tab.name"
          >
            <div v-if="index === 0">
              <!-- {{ currentEmployeeBenefits }} -->
              <div class="p-5">
                <div
                  v-if="currentEmployeeBenefits.length"
                  class="grid lg:grid-cols-4 justify-start gap-y-4 text-sm text-black"
                >
                  <div
                    v-for="benefit in currentEmployeeBenefits"
                    :key="benefit.BenefitId"
                  >
                    <input
                      :id="benefit.BenefitId"
                      :checked="true"
                      :value="benefit.BenefitName"
                      type="checkbox"
                      class="cursor-not-allowed"
                      disabled
                    />
                    <label :for="benefit.BenefitId" class="ml-1">{{
                      benefit.BenefitName
                    }}</label>
                  </div>
                </div>
                <p class="text-center p-2" v-else>No Benefits</p>
              </div>
            </div>

            <div
              v-if="index === 1 && getUserRole.toLowerCase() === 'hrmanager'"
            >
              <BenefitsInfoCard :data="[]" :title="title"></BenefitsInfoCard>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BenefitsInfoCard from "./benefitsInfoCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "Benefits",
  components: { BenefitsInfoCard },
  data() {
    return {
      currentEmployeeBenefits: [],
      title: "Manage Benefits",
      tabs: [
        {
          name: "My Benefits",
          route: "my-benefits",
        },
        {
          name: "Benefits Management",
          route: "benefits-management",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserRole",
      "getCurrentEmployeeId",
    ]),
    filteredTabs() {
      if (this.getUserRole.toLowerCase() === "hrmanager") {
        return this.tabs;
      } else {
        return this.tabs.filter((tab) => tab.name !== "Benefits Management");
      }
    },
  },
  created() {
    this.getMyBenefits();
  },

  methods: {
    handleClose() {
      this.showAddAsset = false;
    },
    setTab() {},
    // /{organization}/employee/{employeeId}/compensation/benefit/v1/request
    getMyBenefits() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/compensation/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.get_success = response.data.StatusMessage;
              // Remove duplicates based on BenefitId
              const uniqueBenefits = response.data.Data.employeeBenefits
                .flatMap(({ Benefits }) => Benefits)
                .filter(
                  (benefit, index, self) =>
                    self.findIndex((b) => b.BenefitId === benefit.BenefitId) ===
                    index
                );

              this.currentEmployeeBenefits = uniqueBenefits;
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
  },
};
</script>
